interface InsuranceRow {
  ID: string;
  Emma: string;
  Empire: string;
  CPP: string;
  UV: string;
  Assumption: string;
  Humania: string;
  Age: string;
  Gender: string;
  'Smoker Status': string;
  'Coverage Amount': string;
}

export const insuranceData: InsuranceRow[] = [
  {
    ID: '40-NS-F-10K',
    Emma: '$13.67',
    Empire: '',
    CPP: '$14.76',
    UV: '',
    Assumption: '$16.80',
    iA: '$16.06',
    Humania: '$15.94',
    Age: '40',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '40-NS-F-25K',
    Emma: '$26.08',
    Empire: '$25.74',
    CPP: '$28.80',
    UV: '$30.71',
    Assumption: '$33.91',
    iA: '$32.04',
    Humania: '$36.47',
    Age: '40',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '40-NS-F-50K',
    Emma: '$46.76',
    Empire: '$46.98',
    CPP: '$47.48',
    UV: '$48.24',
    Assumption: '$50.40',
    iA: '$54.41',
    Humania: '$64.26',
    Age: '40',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '40-NS-M-10K',
    Emma: '$15.09',
    Empire: '',
    CPP: '$15.68',
    UV: '',
    Assumption: '$17.99',
    iA: '$17.48',
    Humania: '$16.23',
    Age: '40',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '40-NS-M-25K',
    Emma: '$29.63',
    Empire: '$29.14',
    CPP: '$31.10',
    UV: '$33.59',
    Assumption: '$36.88',
    iA: '$35.60',
    Humania: '$37.19',
    Age: '40',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '40-NS-M-50K',
    Emma: '$53.87',
    Empire: '$53.78',
    CPP: '$49.01',
    UV: '$54.59',
    Assumption: '$57.06',
    iA: '$59.94',
    Humania: '$65.43',
    Age: '40',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '45-NS-F-10K',
    Emma: '$15.59',
    Empire: '',
    CPP: '$17.33',
    UV: '',
    Assumption: '$18.78',
    iA: '$18.95',
    Humania: '$18.93',
    Age: '45',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '45-NS-F-25K',
    Emma: '$30.87',
    Empire: '$31.03',
    CPP: '$35.21',
    UV: '$36.59',
    Assumption: '$38.86',
    iA: '$39.29',
    Humania: '$43.94',
    Age: '45',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '45-NS-F-50K',
    Emma: '$56.34',
    Empire: '$57.56',
    CPP: '$59.00',
    UV: '$60.39',
    Assumption: '$62.28',
    iA: '$64.44',
    Humania: '$76.77',
    Age: '45',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '45-NS-M-10K',
    Emma: '$17.52',
    Empire: '',
    CPP: '$18.58',
    UV: '',
    Assumption: '$20.30',
    iA: '$20.81',
    Humania: '$19.32',
    Age: '45',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '45-NS-M-25K',
    Emma: '$35.71',
    Empire: '$35.87',
    CPP: '$38.34',
    UV: '$40.75',
    Assumption: '$42.64',
    iA: '$43.92',
    Humania: '$44.93',
    Age: '45',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '45-NS-M-50K',
    Emma: '$66.02',
    Empire: '$67.23',
    CPP: '$61.25',
    UV: '$68.54',
    Assumption: '$69.75',
    iA: '$74.21',
    Humania: '$78.39',
    Age: '45',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
  {
    ID: '50-NS-F-10K',
    Emma: '$17.47',
    Empire: '',
    CPP: '$20.06',
    UV: '$21.42',
    Assumption: '$21.65',
    Humania: '$22.57',
    Age: '50',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '50-NS-F-25K',
    Emma: '$35.57',
    Empire: '$35.87',
    CPP: '$42.05',
    UV: '$45.45',
    Assumption: '$46.04',
    Humania: '$53.06',
    Age: '50',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '50-NS-F-50K',
    Emma: '$65.75',
    Empire: '$67.23',
    CPP: '$72.77',
    UV: '$74.84',
    Assumption: '$74.84',
    Humania: '$93.69',
    Age: '50',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '50-NS-M-10K',
    Emma: '$20.30',
    Empire: '',
    CPP: '$22.64',
    UV: '$22.91',
    Assumption: '$23.65',
    Humania: '$23.15',
    Age: '50',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '50-NS-M-25K',
    Emma: '$42.66',
    Empire: '$41.15',
    CPP: '$48.51',
    UV: '$49.19',
    Assumption: '$51.03',
    Humania: '$54.50',
    Age: '50',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '50-NS-M-50K',
    Emma: '$79.92',
    Empire: '$77.81',
    CPP: '$78.53',
    UV: '$87.66',
    Assumption: '$86.67',
    Humania: '$96.08',
    Age: '50',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '55-NS-F-10K',
    Emma: '$20.66',
    Empire: '',
    CPP: '$23.77',
    UV: '$25.08',
    Assumption: '$25.09',
    Humania: '$28.13',
    Age: '55',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '55-NS-F-25K',
    Emma: '$43.54',
    Empire: '$45.09',
    CPP: '$51.32',
    UV: '$54.61',
    Assumption: '$54.63',
    Humania: '$66.96',
    Age: '55',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '55-NS-F-50K',
    Emma: '$81.68',
    Empire: '$85.68',
    CPP: '$89.82',
    UV: '$95.58',
    Assumption: '$89.82',
    Humania: '$114.21',
    Age: '55',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '55-NS-M-10K',
    Emma: '$24.33',
    Empire: '',
    CPP: '$25.71',
    UV: '$26.37',
    Assumption: '$28.05',
    Humania: '$29.11',
    Age: '55',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '55-NS-M-25K',
    Emma: '$52.72',
    Empire: '$51.28',
    CPP: '$56.18',
    UV: '$57.83',
    Assumption: '$62.03',
    Humania: '$69.39',
    Age: '55',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '55-NS-M-50K',
    Emma: '$100.04',
    Empire: '$98.06',
    CPP: '$96.44',
    UV: '$106.74',
    Assumption: '$105.21',
    Humania: '$118.13',
    Age: '55',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '60-NS-F-10K',
    Emma: '$25.45',
    Empire: '',
    CPP: '$29.98',
    UV: '$30.91',
    Assumption: '$30.92',
    Humania: '$33.67',
    Age: '60',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '60-NS-F-25K',
    Emma: '$55.53',
    Empire: '$59.31',
    CPP: '$66.85',
    UV: '$69.17',
    Assumption: '$69.19',
    Humania: '$80.80',
    Age: '60',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '60-NS-F-50K',
    Emma: '$105.66',
    Empire: '$114.12',
    CPP: '$118.35',
    UV: '$122.63',
    Assumption: '$119.03',
    Humania: '$139.64',
    Age: '60',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '60-NS-M-10K',
    Emma: '$31.08',
    Empire: '',
    CPP: '$34.40',
    UV: '$34.39',
    Assumption: '$35.05',
    Humania: '$35.28',
    Age: '60',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '60-NS-M-25K',
    Emma: '$69.59',
    Empire: '$68.74',
    CPP: '$77.90',
    UV: '$77.87',
    Assumption: '$79.52',
    Humania: '$84.83',
    Age: '60',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '60-NS-M-50K',
    Emma: '$133.79',
    Empire: '$132.98',
    CPP: '$130.32',
    UV: '$146.84',
    Assumption: '$139.82',
    Humania: '$146.21',
    Age: '60',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '65-NS-F-10K',
    Emma: '$33.61',
    Empire: '',
    CPP: '$38.32',
    UV: '$38.84',
    Assumption: '$38.85',
    Humania: '$42.72',
    Age: '65',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '65-NS-F-25K',
    Emma: '$75.92',
    Empire: '$80.33',
    CPP: '$87.71',
    UV: '$89.01',
    Assumption: '$89.03',
    Humania: '$103.43',
    Age: '65',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '65-NS-F-50K',
    Emma: '$146.43',
    Empire: '$156.15',
    CPP: '$156.74',
    UV: '$162.45',
    Assumption: '$156.74',
    Humania: '$171.95',
    Age: '65',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '65-NS-M-10K',
    Emma: '$41.26',
    Empire: '',
    CPP: '$46.67',
    UV: '$45.50',
    Assumption: '$44.66',
    Humania: '$46.46',
    Age: '65',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
  },
  {
    ID: '65-NS-M-25K',
    Emma: '$95.04',
    Empire: '$95.20',
    CPP: '$108.59',
    UV: '$105.64',
    Assumption: '$103.55',
    Humania: '$112.77',
    Age: '65',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
  },
  {
    ID: '65-NS-M-50K',
    Emma: '$184.68',
    Empire: '$185.94',
    CPP: '$183.20',
    UV: '$201.65',
    Assumption: '$187.02',
    Humania: '$182.57',
    Age: '65',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
  },
  {
    ID: '70-NS-F-10K',
    Emma: '$44.84',
    Empire: '$43.84',
    CPP: '$47.33',
    UV: '$53.60',
    Assumption: '$49.67',
    Humania: '$56.27',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '70-NS-F-25K',
    Emma: '$104.00',
    Empire: '$102.85',
    CPP: '$110.23',
    UV: '$125.89',
    Assumption: '$116.08',
    Humania: '$137.30',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '70-NS-F-50K',
    Emma: '$202.59',
    Empire: '$201.20',
    CPP: '$191.97',
    UV: '$225.41',
    Assumption: '$209.88',
    Humania: '$215.73',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '70-NS-M-10K',
    Emma: '$52.83',
    Empire: '$53.28',
    CPP: '$63.98',
    UV: '$63.11',
    Assumption: '$59.48',
    Humania: '$63.35',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '70-NS-M-25K',
    Emma: '$123.98',
    Empire: '$126.45',
    CPP: '$151.85',
    UV: '$149.67',
    Assumption: '$140.60',
    Humania: '$155.00',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '70-NS-M-50K',
    Emma: '$242.55',
    Empire: '$248.40',
    CPP: '$257.72',
    UV: '$287.33',
    Assumption: '$248.45',
    Humania: '$266.58',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '75-NS-F-10K',
    Emma: '$48.92',
    Empire: '$61.44',
    CPP: '$66.69',
    UV: '$74.22',
    Assumption: '$69.76',
    Humania: '$76.84',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '75-NS-F-25K',
    Emma: '$114.21',
    Empire: '$146.86',
    CPP: '$158.63',
    UV: '$177.46',
    Assumption: '$166.30',
    Humania: '$188.73',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '75-NS-F-50K',
    Emma: '$223.02',
    Empire: '$289.22',
    CPP: '$267.21',
    UV: '$333.59',
    Assumption: '$284.58',
    Humania: '$310.41',
    Age: '70',
    Gender: 'Female',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
},
{
    ID: '75-NS-M-10K',
    Emma: '$66.06',
    Empire: '$70.66',
    CPP: '$92.12',
    UV: '$92.12',
    Assumption: '$83.30',
    Humania: '$86.81',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$10,000'
},
{
    ID: '75-NS-M-25K',
    Emma: '$157.05',
    Empire: '$169.90',
    CPP: '$222.21',
    UV: '$222.19',
    Assumption: '$200.14',
    Humania: '$213.64',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$25,000'
},
{
    ID: '75-NS-M-50K',
    Emma: '$308.70',
    Empire: '$335.30',
    CPP: '$356.49',
    UV: '$431.73',
    Assumption: '$335.34',
    Humania: '$409.46',
    Age: '75',
    Gender: 'Male',
    'Smoker Status': 'Non-Smoker',
    'Coverage Amount': '$50,000'
}
];